// finds all filter items from this node below
import { Checkbox } from "./Checkbox";
import RenderAccordion from "./RenderAccordion";
import React from "react";

function itemsBelow(d) {
  if (!d.children) {
    return [d.name];
    // return [d.name, ...(d.includes || [])];
  } else {
    return d.children.flatMap(itemsBelow);
  }
}

export default function FilterTree({
  data = {},
  filterKey = "",
  filterValues = [],
  groups = [],
  name = "",
  path = "",
  onChange = () => {},
  opaque = false,
  selected = [],
  title = "",
  toggleGroup = () => {},
}) {
  // TODO This should be a function that selects all of a group's children
  // if the group is partially selected, or deselects everything of all items
  // in the group are selected
  // const toggleGroup = () => {};

  const renderFilterItem =
    (groupName, className = "") =>
    (g) => {
      // TODO Add filter descriptions as tooltips
      const labelName = `checkbox-${title}-${groupName}-${g.name}`;
      return (
        <div
          className={`flex flex-row items-center ${className}`}
          key={`${labelName}`}
        >
          <Checkbox
            className=""
            type="checkbox"
            name={labelName}
            label={g.name}
            color={g.rgba || "white"}
            data-filter-key={filterKey}
            data-filter-value={g.name}
            checked={selected.indexOf(g.name) >= 0}
            renderAs={g.filter_shape || "square"}
            tooltip={g.description}
            opaqueCheckbox={opaque || false}
            onChange={(e) => {
              // returns new filter state values
              const { filterValue, filterKey } = e.target.dataset;
              onChange({
                [filterKey]: {
                  all: filterValues,
                  selected: e.target.checked
                    ? selected.concat(filterValue, g.includes || [])
                    : selected.filter(
                        (d) =>
                          [filterValue, ...(g.includes || [])].indexOf(d) < 0
                      ),
                  groups,
                },
              });
            }}
          />
        </div>
      );
    };

  return (
    <div className="col-12">
      <div className="filter-group__values flex flex-row flex-wrap items-center my1">
        {Array.isArray(data)
          ? data.map((d) => {
              const pathName = `${path}/${d.name}`;
              return d.children ? (
                <RenderAccordion
                  key={`filter-tree-${d.name}`}
                  color={d.rgba || `white`}
                  className="col-12"
                  name={d.name}
                  path={pathName}
                  onSelectGroup={toggleGroup(pathName)}
                  itemsBelow={d.children.flatMap(itemsBelow)}
                  selected={selected}
                >
                  <FilterTree
                    data={d.children}
                    filterKey={filterKey}
                    filterValues={filterValues}
                    // former if we're recursively iterating, latter if on root
                    opaque={d.opaque || opaque}
                    groups={groups}
                    name={d.name}
                    path={pathName}
                    onChange={onChange}
                    selected={selected}
                    title={title}
                    toggleGroup={toggleGroup}
                  />
                </RenderAccordion>
              ) : (
                renderFilterItem(name, "mt1 mr1 col-12")(d)
              );
            })
          : renderFilterItem(name, "col-12")(data)}
      </div>
    </div>
  );
}
